module.exports = __webpack_public_path__ + "img/arrow.7fcc85d3.png";